import React from 'react';
import CDNImage from './CDNImage';

function Loading({ style }) {
    return <CDNImage assetName={'loading.gif'} style={style} alt="Loading animation" />
}

export default Loading;
